<div class="modal-header modal-xxl">
  <h4 class="modal-title">{{ title }}</h4>
  <button (click)="close()" aria-label="Close" class="modal-close" type="button">
    <font-awesome [icon]="'fa-regular fa-xmark'"></font-awesome>
  </button>
</div>
<div class="modal-body mb-40px">
  <h6>{{ product.productName }}</h6>
  <div class="d-flex flex-row label-value mb-16px">
    <div>MODEL NUMBER:</div>
    <div>{{ product.modelCode }}</div>
    <div class="pl-12px">SERIAL NUMBER:</div>
    <div>{{ product.serialNo }}</div>
  </div>
  <div class="table-wrapper py-0">
    <perfect-scrollbar [style.height]="'380px'">
      <table class="table align-middle table-nowrap m-0">
        <thead>
        <tr>
          <th scope="col">Ticket No.</th>
          <th scope="col">Model</th>
          <th scope="col">Type</th>
          <th scope="col">Wty</th>
          <th scope="col">ASC</th>
          <th scope="col">Post Date</th>
          <th scope="col">Create</th>
          <th scope="col">Status</th>
        </tr>
        </thead>
        <tbody class="border border-white">
        <tr *ngFor="let history of productHistoryList">
          <td>{{ history.ticketNo }}</td>
          <td>{{ history.modelCode }}</td>
          <td>{{ history.serviceType }} / {{ history.detailType }}</td>
          <td>{{ history.warrantyTerm }}</td>
          <td>{{ history.ascNo }}</td>
          <td>{{ history.postingDate | localDate }}</td>
          <td>{{ history.createDate | localDate }}</td>
          <td class="d-flex">
            <dp-badge [color]="'#0064ff'" [size]="'wd-xxs'" [text]="history.status"></dp-badge>
            <dp-badge [color]="'#D2398C'" [size]="'wd-xxs'" [text]="history.reason" class="pl-4x"></dp-badge>
          </td>
        </tr>
        </tbody>
      </table>
    </perfect-scrollbar>
  </div>
</div>
